var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EbxStaggeringTransitionGroup',{staticClass:"ebx-related-tags",attrs:{"appear":true,"name":_vm.animationName,"tag":"ul"}},[_vm._t("default",null,{"classNames":'ebx-related-tags__item',"relatedTags":_vm.sortedRelatedTags})],2)}
var staticRenderFns = []

export { render, staticRenderFns }